// Dark/light versions of the brand banner; CSS shows the one matching the theme
export const BrandLogo = ({ testId = "auth-logo" }) => (
  <div data-testid={testId}>
    <img src="/logo-hero.png" alt="LA Marcenaria Corte Rápido CNC" className="logo-dark w-full h-auto rounded-md" data-testid={`${testId}-dark`} />
    <img src="/logo-hero-light.png" alt="LA Marcenaria Corte Rápido CNC" className="logo-light w-full h-auto rounded-md" data-testid={`${testId}-light`} />
  </div>
);
